import { render } from "./ModalZones.vue?vue&type=template&id=36736d0a"
import script from "./ModalZones.vue?vue&type=script&lang=js"
export * from "./ModalZones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__